/* eslint-disable */
import { getCachedStore, getCanList } from '../auth';
import _0 from './_0';
import _1 from './_1';
import _2 from './_2';
import _3 from './_3';
import _4 from './_4';
import _6 from './_6';
import _7 from './_7';

const getMenuByCanList = async (menuItems, store) => {
  const canlist = await getCanList();
  return menuItems.filter(item => {
    if (item.needcan && !canlist.includes(item.needcan)) {
      return false;
    }
    if (!item.children) {
      return true;
    }
    item.children = item.children.filter(item1 => {
      if (item1.needcan && !canlist.includes(item1.needcan)) {
        return false;
      }
      return true;
    });
    if (item.children.length === 0) {
      return false;
    }
    return true;
  });
};

export default async () => {
  const store = await getCachedStore();
  const kind = store.kind;
  if (kind === 0) {
    return getMenuByCanList(_0, store);
  }
  if (kind === 1) {
    return getMenuByCanList(_1, store);
  }
  if (kind === 2) {
    return getMenuByCanList(_2, store);
  }
  if (kind === 3) {
    return getMenuByCanList(_3, store);
  }
  if (kind === 4) {
    return getMenuByCanList(_4, store);
  }
  if (kind === 6) {
    return getMenuByCanList(_6, store);
  }
  if (kind === 7) {
    return getMenuByCanList(_7, store);
  }
  return [];
};
